import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

// Minimal hook mirroring RevenuePerHour but for Appointment Engagement
// Endpoint path chosen by convention; backend must provide it.
export const useAppointmentEngagement = (params, options = {}) => {
  return useQuery(
    ["appointmentEngagement", params],
    async () => http.get(HTTP_ENDPOINTS.getAppointmentEngagement(), { params }),
    { ...options, cacheTime: 0 },
  );
};
